import { useEffect, useState } from 'react';
import { addDoc, collection, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

export const savePokerHandForUser = async (uid, pokerHand) => {
  const handRef = await addDoc(collection(db, 'users', uid, 'hands'), pokerHand);
  return handRef.id;
};

export const usePokerHand = (uid, pokerHandId) => {
  const [pokerHand, setPokerHand] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid || !pokerHandId) {
      setPokerHand(null);
      setLoading(false);
      return;
    }

    const fetchPokerHand = async () => {
      setLoading(true);
      try {
        const pokerHandRef = doc(db, 'users', uid, 'hands', pokerHandId);
        const snapshot = await getDoc(pokerHandRef);
        if (snapshot.exists()) {
          setPokerHand(snapshot.data());
        } else {
          setPokerHand(null);
        }
      } catch (error) {
        console.error('Error fetching poker hand:', error);
        setPokerHand(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPokerHand();
  }, [uid, pokerHandId]);

  return { pokerHand, loading };
};
